import { useState, useEffect } from "react";
import { useProductosBom } from "../../../../contexto/provider/ProductosBomContext.js";
import { useProductos } from "../../../../contexto/provider/ProductosContext.js";

import "./formCreacion.css";

export default function AgregarProductoBomForm({ productoCodigo }) {
  const { agregarProductoBom } = useProductosBom();
  const [cargando, setCargando] = useState(false);
  const { productos, insumos, cargarProductosInsumos, cargarProductos } =
    useProductos();

    
  const [form, setForm] = useState({
    producto_linea: productoCodigo || "",
    producto_insumo: "",
    cantidad: 1,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const resultado = await agregarProductoBom({
        producto_linea: Number(form.producto_linea),
        producto_insumo: Number(form.producto_insumo),
        cantidad: Number(form.cantidad),
        unidad: "UND",
      });

      if (!resultado.success) {
        setError(resultado.error);
        return;
      }

      setSuccess(true);

      setForm({
        producto_insumo: "",
        cantidad: 1,
      });
    } catch (err) {
      setError("Error inesperado");
    }

    setLoading(false);
  };

  // METODO PARA PROPS
  useEffect(() => {
    if (productoCodigo) {
      setForm((prev) => ({
        ...prev,
        producto_linea: productoCodigo,
      }));
    }
  }, [productoCodigo]);

  // CARGAR PRODUCTOS
  useEffect(() => {
    const cargarTodos = async () => {
      await Promise.all([cargarProductos(), cargarProductosInsumos()]);
    };

    cargarTodos();
  }, [cargarProductos, cargarProductosInsumos]);

return (
  <div className="form-container">
    {/* Botón para recargar productos */}
    <div >
      <button
        type="button"
        className="btn-android w-100"
        onClick={async () => {
          try {
            setCargando(true);
            await cargarProductos();
            await cargarProductosInsumos();
          } catch (err) {
            console.error("Error al refrescar:", err);
          } finally {
            setCargando(false);
          }
        }}
      >
        {cargando ? "Cargando..." : "Recargar Productos"}
      </button>
    </div>

    {/* Formulario */}
    <form className="form-card" onSubmit={handleSubmit}>
  <h3 className="form-title">Agregar Insumo al Producto</h3>

  <div className="form-fields-row">
    <div className="form-group">
      <label htmlFor="producto_linea" className="form-label">Producto Línea</label>
      <select id="producto_linea" name="producto_linea" value={form.producto_linea} onChange={handleChange} className="form-input" required>
        <option value="">Seleccione Producto Línea</option>
        {productos.map(p => <option key={p.Codigo} value={p.Codigo}>{p.Codigo} - {p.nombre}</option>)}
      </select>
    </div>

    <div className="form-group">
      <label htmlFor="producto_insumo" className="form-label">Insumo</label>
      <select id="producto_insumo" name="producto_insumo" value={form.producto_insumo} onChange={handleChange} className="form-input" required>
        <option value="">Seleccione Insumo</option>
        {insumos.map(i => <option key={i.Codigo} value={i.Codigo}>{i.Codigo} - {i.nombre}</option>)}
      </select>
      
    </div>

   <div className="form-group-row">
  <div className="form-group">
    <label htmlFor="cantidad" className="form-label">Cantidad</label>
    <input
      type="number"
      id="cantidad"
      name="cantidad"
      value={form.cantidad}
      onChange={handleChange}
      min="1"
      className="form-input"
      required
    />
  </div>

  <div className="form-group">
    <label htmlFor="volumen" className="form-label">Volumen</label>
    <select
      id="volumen"
      name="volumen"
      value={form.volumen}
      onChange={handleChange}
      className="form-input"
      required
    >
      <option value="">Seleccione Volumen</option>
      <option>Gramos</option>
      <option>Mililitros</option>
      <option>Unidades</option>
      <option>Litros</option>
      <option>Kilogramos</option>
      <option>Bolsas</option>
      <option>Cajas</option>
    </select>
  </div>
</div>

  </div>
  
  

  <div className="form-btn-bottom">
    <button type="submit" className="btn-android w-100" disabled={loading || !form.producto_linea || !form.producto_insumo}>
      {loading ? "Agregando..." : "Agregar Insumo"}
    </button>
  </div>

  {error && <p className="form-msg error">{error}</p>}
  {success && <p className="form-msg success">Insumo agregado correctamente</p>}
</form>
  </div>

);
}

